export default __webpack_public_path__ + "static/media/midCloudTwo.2f540f8f.jpg";